var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-tabs',[_c('v-tab',[_vm._v(" Dienstkleidung ")]),_c('v-tab-item',[_c('ShopOrder')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }